<template>
    <div class="column">
        <div class="card tilebox-one">
            <div class="card-body">
                <i class="dripicons-basket float-end text-muted"></i>
                <h6 class="text-muted text-uppercase mt-0">Billing</h6>
                <h2 class="m-b-20"><animated-number :value="+billingPercent" />%</h2>
                <span class="badge" :class="{'bg-primary' : previousBillingPercent > 0, 'bg-alert' : previousBillingPercent <= 0}"> <animated-number :value="+previousBillingPercent" />% </span> <span class="text-muted">From previous</span>
            </div>
        </div>
    </div>
</template>
<script>
    import AnimatedNumber from '../../../../components/AnimatedNumber.vue'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        components: {
            AnimatedNumber
        },
        props: {
            params: null,
            paramsPrevious: null,
            user: {},
            value: null
        },
        data() {
            return {
                billingData: {
                    current: {},
                    previous: {}
                },
                syncTimeout: null
            }
            
        },
        mounted() {
            this.fillBillingData();
        },
        watch: {
            'params'(value) {
                this.fillBillingData()
            },
            'paramsPrevious' (value) {
                this.fillBillingData()
            },
            'billingData.current' (value) {
                this.$emit('input', this.billingObject)
            },
            'billingData.previous' (value) {
                this.$emit('input', this.billingObject)
            },
        },
        methods: {
            ...mapActions(['getBillingGrouped']),
            fillBillingData() {
                if (this.syncTimeout) {
                    clearTimeout(this.syncTimeout)
                }

                this.syncTimeout = setTimeout(() => {
                    this.getBillingGrouped(this.params).then(res => this.billingData.current = res.data.data[0] || { price : 0 })
                    this.getBillingGrouped(this.paramsPrevious).then(res => this.billingData.previous = res.data.data[0] || { price : 0 })
                }, 250)
            },
            calcPercent(a, b) {
                return Math.round((a / b) * 1000) /10
            }
            
        },
        computed: {
            billingObject() {
                return { billingData: this.billingData, billingPercent: this.billingPercent, previousBillingPercent: this.previousBillingPercent }
            },
            billingPercent() {
                return isFinite(this.calcPercent(+this.billingData.current.price, this.user.monthly_goal))? this.calcPercent(+this.billingData.current.price, this.user.monthly_goal) : 0
            },
            previousBillingPercent() {
                if(+this.billingData.current.price != 0 && +this.billingData.previous.price > 0)
                {
                  let diff = +this.billingData.current.price - +this.billingData.previous.price
                  let curr = this.calcPercent(diff, +this.billingData.current.price)
                  return curr ? curr : +this.billingData.previous.price > 0 ? -100 :  0
                }
                else
                {
                  return 0;
                }
            }
        }
    }
</script>